<label class="switch">
  <input type="checkbox" [(ngModel)]="value" checked="value" [disabled]="isDisabled" (click)="onClick($event)" />
  <span class="slider round"></span>
</label>
